// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"31":"6d38576f","572":"feb519c4","974":"4e5e0c90"}[chunkId] + ".js";
};